import { Card, Typography } from "@mui/material";
import React from "react";
import { commonStyles } from "../styles/commonStyles"; 

interface IToolbarProps {
    title: string
}

export const ToolBarComponent: React.FunctionComponent<IToolbarProps> = (props: IToolbarProps) => {
    const commonStyle = commonStyles()

    return (
        <Card className={commonStyle.toolbar}>
            <Typography
                style={{
                    color: '#d99888'
                }}
                component="h5" variant="h5"
            >
                {props.title}
            </Typography>
        </Card>
    )
}
